import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Web3Provider, useWeb3 } from './context/Web3Context';
import { useNotification } from './hooks/useNotification';
import Navbar from './components/Navbar';
import BottomNav from './components/BottomNav';
import NetworkGuard from './components/NetworkGuard';
import Notification from './components/Notification';
import Dashboard from './pages/Dashboard';
import Matrix from './pages/Matrix';
import Pools from './pages/Pools';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import './styles/global.css';

function AppContent() {
  const { setupListeners } = useWeb3();
  const { notifications, notify, removeNotification } = useNotification();

  useEffect(() => {
    setupListeners();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Navbar onNotify={notify} />
      <Notification notifications={notifications} onRemove={removeNotification} />
      <NetworkGuard />
      <Routes>
        <Route path="/" element={<Dashboard onNotify={notify} />} />
        <Route path="/matrix" element={<Matrix onNotify={notify} />} />
        <Route path="/pools" element={<Pools onNotify={notify} />} />
        <Route path="/profile" element={<Profile onNotify={notify} />} />
        <Route path="/admin" element={<Admin onNotify={notify} />} />
      </Routes>
      <BottomNav />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Web3Provider>
        <AppContent />
      </Web3Provider>
    </BrowserRouter>
  );
}
